import React, { useState } from "react";
import "./Contact.css";

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
        alert('Thank you for your message! We will contact you soon.');
        setFormData({
            name: '',
            email: '',
            phone: '',
            service: '',
            message: ''
        });
    };

    const contactInfo = [
        { icon: "✉", label: "Email", lines: ["Info@euro-light.net"] },
        { icon: "☎", label: "Phone", lines: ["eng.Baraa: 0507374782", "Manager.Saeed: 0504597173"] },
        { icon: "📍", label: "Location", lines: ["Dubai, United Arab Emirates"] },
        { icon: "⏰", label: "Business Hours", lines: ["Sunday – Friday: 8:00 AM – 6:00 PM", "Saturday – Sunday: Closed"] },
    ];

    return (
        <section id="contact-form" className="contact">
            <div className="contact__container">
                <div className="section-heading">
                    <span className="section-heading__label">Let's Talk</span>
                    <h2 className="section-heading__title">Get In Touch</h2>
                    <span className="section-heading__bar"></span>
                </div>

                <div className="contact__grid">
                    {/* ── Info Column ── */}
                    <div className="contact__info">
                        <h3 className="contact__info-title">Contact Information</h3>
                        <p className="contact__info-subtitle">
                            Reach out and let us illuminate your next project.
                        </p>

                        <div className="contact__info-list">
                            {contactInfo.map((item, i) => (
                                <div className="contact__info-item" key={i}>
                                    <span className="contact__info-icon">{item.icon}</span>
                                    <div>
                                        <h4 className="contact__info-label">{item.label}</h4>
                                        {item.lines.map((line, j) => (
                                            <p className="contact__info-value" key={j}>{line}</p>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* ── Form Column ── */}
                    <div className="contact__form-wrapper">
                        <form className="contact__form" onSubmit={handleSubmit}>
                            <div className="contact__form-row">
                                <div className="contact__field">
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Full Name *"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        className="contact__input"
                                    />
                                </div>
                                <div className="contact__field">
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Email Address *"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        className="contact__input"
                                    />
                                </div>
                            </div>

                            <div className="contact__form-row">
                                <div className="contact__field">
                                    <input
                                        type="tel"
                                        name="phone"
                                        placeholder="Phone Number"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className="contact__input"
                                    />
                                </div>
                                <div className="contact__field">
                                    <select
                                        name="service"
                                        value={formData.service}
                                        onChange={handleChange}
                                        required
                                        className="contact__input contact__input--select"
                                    >
                                        <option value="">Select Service *</option>
                                        <option value="lighting-design">Lighting Design</option>
                                        <option value="electrical-installation">Electrical Installation</option>
                                        <option value="maintenance">Maintenance &amp; Support</option>
                                        <option value="consultation">Consultation</option>
                                        <option value="smart-lighting">Smart Lighting Systems</option>
                                        <option value="outdoor-lighting">Outdoor Lighting</option>
                                        <option value="emergency-lighting">Emergency Lighting</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>
                            </div>

                            <div className="contact__field">
                                <textarea
                                    name="message"
                                    placeholder="Tell us about your project *"
                                    rows="5"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    className="contact__input contact__input--textarea"
                                ></textarea>
                            </div>

                            <button type="submit" className="contact__submit">
                                Send Message
                                <span className="contact__submit-arrow">→</span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;
